var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExplore = function SvgExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-3.934-4.524c-.454-.588-.25-1.533.155-3.423.306-1.423.459-2.135.903-2.65.086-.1.179-.193.278-.278.516-.445 1.228-.598 2.65-.904 1.89-.406 2.836-.609 3.424-.155a1.6 1.6 0 0 1 .288.289c.454.588.251 1.533-.155 3.423-.305 1.423-.458 2.135-.903 2.65-.086.1-.178.192-.278.278-.516.445-1.227.598-2.65.904-1.89.405-2.835.608-3.423.155a1.597 1.597 0 0 1-.29-.29Zm4.792-4.503a1.333 1.333 0 1 1-1.886 1.885 1.333 1.333 0 0 1 1.886-1.885Z",
    clipRule: "evenodd"
  })));
};
export default SvgExplore;